module.exports = __webpack_public_path__ + "img/banner-product.9cb79474.jpg";